import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  branch,
  compose,
  lifecycle,
  renderNothing,
} from 'recompose';

import withPermissions from '../../auth/utils/withPermissions';
import { canUserUseHandoff } from '../../common/helpers/users';
import { setHandoff } from '../../register/payment/reducer/handoff/actions';
import { isHandoffActive } from '../../register/payment/reducer/handoff/selectors';
import { getBusy, getError, getFetching, getTimeout } from '../selectors';
import errorRenderer from './hoc/errorRenderer';
import processingRenderer from './hoc/processingRenderer';
import successRenderer from './hoc/successRenderer';
import { getCurrentUserUsername, getActiveShop } from '../../auth/selectors';

export default compose(
  withPermissions,
  branch(
    props => !canUserUseHandoff(props.permissions),
    renderNothing,
  ),
  connect(
    state => ({
      checked: isHandoffActive(state),
      pending: getFetching(state),
      busy: getBusy(state),
      error: getError(state),
      timeout: getTimeout(state),
      username: getCurrentUserUsername(state),
      shopName: getActiveShop(state).name,
    }),
    { onChange: setHandoff },
  ),
  lifecycle({
    componentDidMount() {
      const handoffBarHeight = getComputedStyle(document.documentElement)
        .getPropertyValue('--handoff-bar-expanded-height');

      document.documentElement.style.setProperty('--handoff-bar-height', handoffBarHeight);
      document.documentElement.classList.add('s-handoff');
    },
    componentWillUnmount() {
      document.documentElement.style.setProperty('--handoff-bar-height', '0px');
      document.documentElement.classList.remove('s-handoff');
    },
  }),
  withRouter,
  errorRenderer,
  successRenderer,
  processingRenderer,
);
